export type OfjType =
  | 'VARIETAL_WINE_PROTECTED_GEOGRAPHICAL_INDICATION'
  | 'VARIETAL_WINE_MOT_PROTECTED_GEOGRAPHICAL_INDICATION'
  | 'NOT_VARIETAL_WINE_NOT_PROTECTED_GEOGRAPHICAL_INDICATION';

export const OfjType = {
  varietalWineProtectedGeographicalIndication:
    'VARIETAL_WINE_PROTECTED_GEOGRAPHICAL_INDICATION' as OfjType,
  varietalWineMotProtectedGeographicalIndication:
    'VARIETAL_WINE_MOT_PROTECTED_GEOGRAPHICAL_INDICATION' as OfjType,
  notVarietalWineNotProtectedGeographicalIndication:
    'NOT_VARIETAL_WINE_NOT_PROTECTED_GEOGRAPHICAL_INDICATION' as OfjType,
};
